import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import MuiTextField from "@mui/material/TextField";
import TextField from "components/textfield";

const SCOPE_OPTIONS = [
  { value: "is_app_folio_property_id", label: "Property ID" },
  { value: "is_app_folio_property_group_id", label: "Property Group ID" },
];

function AppFolioSystem({ credentials = {}, onChange }) {
  const [form, setForm] = useState({
    appFolioPropertyScope: credentials?.appFolioPropertyScope ?? "is_app_folio_property_id",
    appFolioDatabaseId: credentials?.appFolioDatabaseId ?? "",
    appFolioPropertyId: credentials?.appFolioPropertyId ?? "",
    appFolioPropertyGroupId: credentials?.appFolioPropertyGroupId ?? "",
  });

  const update = (patch) => {
    const next = { ...form, ...patch };
    setForm(next);
    onChange?.(next);
  };

  const handleScopeChange = (e) => {
    update({
      appFolioPropertyScope: e.target.value,
    });
  };

  return (
      <Grid container paddingY='1rem' spacing={2}>
        <Grid item xs={3}></Grid>
        
        {/* Property Scope */}
        <Grid item xs={12} md={6}>
          <MuiTextField
            select
            fullWidth
            required
            label="Property Scope"
            value={form.appFolioPropertyScope}
            onChange={handleScopeChange}
          >
            {SCOPE_OPTIONS.map((opt) => (
              <MenuItem key={opt.value} value={opt.value}>
                {opt.label}
              </MenuItem>
            ))}
          </MuiTextField>
        </Grid>
        
        <Grid item xs={3}></Grid>
        <Grid item xs={3}></Grid>

        {/* Property / Group ID */}
        <Grid item xs={12} md={6}>
          {form.appFolioPropertyScope === "is_app_folio_property_id" ? (
            <TextField
              required
              label="Property ID"
              value={form.appFolioPropertyId}
              onChange={(e) =>
                update({ appFolioPropertyId: e.target.value })
              }
            />
          ) : (
            <TextField
              required
              label="Property Group ID"
              value={form.appFolioPropertyGroupId}
              onChange={(e) =>
                update({ appFolioPropertyGroupId: e.target.value })
              }
            />
          )}
        </Grid>
        
        <Grid item xs={3}></Grid>
        <Grid item xs={3}></Grid>

        {/* Database ID */}
        <Grid item xs={12} md={6}>
          <TextField
            required
            label="Database ID"
            value={form.appFolioDatabaseId}
            onChange={(e) =>
              update({ appFolioDatabaseId: e.target.value })
            }
          />
        </Grid>
      </Grid>
  );
}

export default AppFolioSystem;